/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Captain_DescInputs */

const es_nav_m_captain_desc = /** @type {(inputs: Nav_M_Captain_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate como patrón`)
};

const gl_nav_m_captain_desc = /** @type {(inputs: Nav_M_Captain_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexístrate como patrón`)
};

const en_nav_m_captain_desc = /** @type {(inputs: Nav_M_Captain_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register as a skipper`)
};

/**
* | output |
* | --- |
* | "Register as a skipper" |
*
* @param {Nav_M_Captain_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_captain_desc = /** @type {((inputs?: Nav_M_Captain_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Captain_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_captain_desc(inputs)
	if (locale === "en") return en_nav_m_captain_desc(inputs)
	return es_nav_m_captain_desc(inputs)
});